import React from 'react';
import { Facebook, ExternalLink } from 'lucide-react';
import { content } from '../data';

const SocialMedia = () => {
  return (
    <section className="py-20 bg-slate-50 text-slate-900 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-[#034b89] text-white p-8 md:p-16 overflow-hidden shadow-2xl">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 -mt-20 -mr-20 w-64 h-64 bg-[#034b89] rounded-full opacity-20 blur-3xl"></div>
          <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-64 h-64 bg-[#034b89] rounded-full opacity-20 blur-3xl"></div>
          
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-12">
            <div className="md:w-1/2">
              <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/10 text-blue-100 mb-6 border border-white/20">
                <Facebook className="w-5 h-5 mr-2" />
                <span className="text-sm font-semibold tracking-wide uppercase">Følg mig på Facebook</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
                Hold dig opdateret med mine seneste nyheder
              </h2>
              <p className="text-xl text-blue-100 mb-8 max-w-lg leading-relaxed">
                Følg Lenes Køreskole på Facebook for at se succesoplevelser fra mine elever, få gode råd til din køreuddannelse og læse anmeldelser.
              </p>
              <a 
                href={content.contact.facebook} 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center px-8 py-4 bg-white text-[#034b89] rounded-full font-bold text-lg hover:bg-blue-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Besøg min side
                <ExternalLink className="ml-2 w-5 h-5" />
              </a>
            </div>
            
            <div className="md:w-1/2 flex justify-center">
              <div className="relative">
                <div className="w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden border-8 border-white/10 shadow-2xl transform rotate-3">
                  <img 
                    src="/Kundebilleder/imgi_17_Forside-faerdig-2.jpg" 
                    alt="Lenes Køreskole Facebook" 
                    className="w-full h-full object-cover"
                  />
                </div>
                {/* Floating Badge */}
                <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-2xl shadow-xl transform -rotate-6">
                  <div className="flex items-center gap-3">
                    <div className="bg-blue-50 p-2 rounded-lg">
                      <Facebook className="w-6 h-6 text-[#034b89]" />
                    </div>
                    <div>
                      <p className="text-slate-900 font-bold leading-none">5/5 Stjerner</p>
                      <p className="text-slate-500 text-xs mt-1">på Facebook</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialMedia;
